export default __webpack_public_path__ + "static/media/Taxi_fares.e57ed081.png";